import { FETCH_PROFILE } from "../constants/actions.type";
import { SET_ERROR, SET_LOADING, SET_USER } from "../constants/mutations.type";
import UserService from "@/services/resources/user.service";
import LocalStorageService from "@/common/LocalStorageService";
import {
  FLAG_ADMIN,
  FLAG_MRO,
  FLAG_ALL,
  FLAG_EXCEPT_6,
  FLAG_1_8,
  FLAG_1_2
} from "@/common/constant";

const initialState = () => ({
  profile: null,
  error: true,
  loading: false
});

const states = initialState();

const getters = {
  profile(state) {
    return state.profile;
  },
  profileLoading(state) {
    return state.loading;
  },
  isAdmin(state) {
    return (
      state.profile &&
      state.profile.listRoles.some(role => role?.name?.toLowerCase() == "admin")
    );
  },
  profileFlagAll(state) {
    return state.profile && FLAG_ALL.some(d => d == state.profile.flag);
  },
  profileFlagAdmin(state) {
    return state.profile && FLAG_ADMIN.some(d => d == state.profile.flag);
  },
  profileFlagMRO(state) {
    return state.profile && FLAG_MRO.some(d => d == state.profile.flag);
  },
  profileFlagExcept6(state) {
    return state.profile && FLAG_EXCEPT_6.some(d => d == state.profile.flag);
  },
  isListRoleContain6(state) {
    const jobNames =
      state.profile?.listRoles.map(listRole => listRole.jobName) || [];
    return jobNames.indexOf("6") > -1;
  },
  profileFlag1_8(state) {
    return state.profile && FLAG_1_8.some(d => d == state.profile.flag);
  },
  profileFlag1_2(state) {
    return state.profile && FLAG_1_2.some(d => d == state.profile.flag);
  }
};

const actions = {
  [FETCH_PROFILE](context) {
    function fetchProfileFromUserService(context) {
      return new Promise(resolve => {
        context.commit(SET_LOADING, true);
        UserService.getCurrent()
          .then(handleProfileData(context, resolve))
          .catch(handleProfileError(context))
          .finally(() => context.commit(SET_LOADING, false));
      });
    }

    function handleProfileData(context, resolve) {
      return ({ data }) => {
        const { message, result } = data;
        if (message === "OK") {
          const dataProfile = result;
          dataProfile.acronymName = dataProfile.name
            ? dataProfile.name
                .match(/\b(\w)/g)
                .join("")
                .substring(0, 2)
            : "Anonymous";
          dataProfile.flag = dataProfile.flag || "other";
          LocalStorageService.saveProfile(JSON.stringify(dataProfile));
          context.commit(SET_USER, dataProfile);
          resolve(data);
        }
      };
    }

    function handleProfileError(context) {
      return ({ response }) => {
        if (response) {
          const { data } = response;
          context.commit(SET_ERROR, data.message);
        }
      };
    }

    const profile = LocalStorageService.getProfile();
    if (profile) {
      context.commit(SET_USER, JSON.parse(profile));
    } else {
      return fetchProfileFromUserService(context);
    }
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_LOADING](state, data) {
    state.loading = data;
  },
  [SET_USER](state, data) {
    state.profile = data;
  }
};

export default {
  // namespaced: true,
  state: states,
  getters,
  actions,
  mutations
};
